import axios from "axios";
import { combinedUrls } from "../../../URL/functions";
import { validationBacklogUrls } from "../../../URL/ApplicationUrls";

export type PdsrValidationItemExistsRequest = {
  Id: number | null;
  ContainerNetwork: string;
  SupplierGsdb: string;
  PlantGsdb: string;
  InboundDock: string;
  OutboundDock: string;
  FoldedFlag: string;
  ContainerType: string;
};

export default async (data: PdsrValidationItemExistsRequest) => {
  const existsUrl = combinedUrls(validationBacklogUrls.pdsrs.apiUrl, "Exists");

  const response = await axios.post(existsUrl, data);
  return response.data as boolean;
};
